
<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0 ; height: 100%">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-cell-group>

                <van-field
                        v-model="keywords"
                        :rules="[{ required: true, message: '' }]"
                        label="单位名称"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入单位关键字"
                ><template #button>
                    <van-button @submit.prevent  native-type="button" @click="searchUser" size="small" type="primary">搜索</van-button>
                </template>
                </van-field>
                <div  class="operate-desc-left">请输入单位名称或者部分关键字，系统会模糊匹配</div>
                <van-radio-group  >
                    <van-cell @click="formData.user_id=user.id;formData.phone=user.phone" v-for="(user,index) in userList" :title="user.danwei" is-link  v-show="formData.user_id==0 || formData.user_id==user.id"  >
                        <template #label>
                            用户组：{{user.rolename}}<br/>
                            用户名：{{user.name}}<br/>
                            手机： {{user.phone|hide}}
                        </template>
                    </van-cell>
                </van-radio-group>

                <van-field
                        v-if="formData.user_id"
                        v-model="formData.phone2"
                        :rules="[{ required: true, message: '请输入完整的手机号' }]"
                        label="手机号"
                        type="number"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入完整的手机号"
                />
                <van-field
                        v-if="formData.user_id"
                        v-model="formData.password"
                        :rules="[{ required: true, message: '请输入密码' }]"
                        label="新密码"
                        type="password"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入CCA官网新密码"
                />
                <van-field
                        v-if="formData.user_id"
                        v-model="formData.password2"
                        :rules="[{ required: true, message: '请再次输入密码' }]"
                        label="重复密码"
                        type="password"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请再次输入密码"
                />


            </van-cell-group>

            <div class="savebtn"
                 v-if="formData.user_id">
                <van-button
                        style="width: 3rem"
                        size="normal" round   @submit.prevent  native-type="button" @click="formData.user_id=0">重新选择</van-button>
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">重置密码</van-button>
            </div>
        </van-form>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }


    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        margin-left: 10px;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import namekey from "../../../utils/namekey";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button,Calendar} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Calendar).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'CertDanweiBind',
        components: {
            PicUploader,
        },
        data: function () {
            return {
                validator,
                showDate:false,
                showArea:false,
                userId:0,
                showNamekey:false,
                namekeyList:{},
                saveLoading:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                minDate: new Date((new Date()).valueOf()+3600*24*15*1000), //15天后
                keywords:'',
                userList:[],
                formData: {
                    user_id: 0,
                    phone:'',
                    phone2:'',
                    password:'',
                    password2:'',
                },
            }
        },
        filters: {
            hide(val){
                return   val.substr(0,val.length-4)+('****') ;
            }

        },
        mounted() {
            let that = this;
          document.title="忘记密码"
            that.areaList = area;
            that.namekeyList = namekey;
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            searchUser(){
                let that = this;
                that.formData.user_id = 0;
                if(!that.keywords){
                    Toast('请输入关键字');
                    return
                }
                that.saveLoading = true;
                that.$api.post('/api/user/searchUserByDanwei', {
                    keywords: that.keywords
                }, (res) => {
                    that.saveLoading = false;
                    that.userList = res.data;
                }, (res) => {
                    Toast(res.msg);
                    that.saveLoading = false;
                    that.userList = [];
                })
            },
            onQuestion(){
                console.log('onQuestion')
            },
            onNamekeyConfirm(values) {
                console.log(values);
                this.formData.namekey = values[2].code;
                this.formData.nprovince = values[0].name;
                this.formData.ncity = values[1].name;
                this.formData.ncounty = values[2].name;
                this.showNamekey = false;
            },
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                }

                if(that.formData.phone != that.formData.phone2){
                    Toast('手机号不匹配');
                    return
                }
                if(that.formData.password.length<6){
                    Toast('密码不能少于6位');
                    return
                }
                if(that.formData.password != that.formData.password2){
                    Toast('两次密码输入不一致');
                    return
                }

                that.saveLoading = true;

                that.$api.post('/api/user/resetpasswordbydanwei', that.formData, (res) => {
                    that.saveLoading = false;
                    rbLink({
                        name:'CertDanweiResult',
                    },'back')
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },

        }
    }
</script>



// WEBPACK FOOTER //
// ForgetCcaUser.vue?43e44737